import { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

export default function AllProducts() {
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get('search') || '';
  const [cartCount, setCartCount] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [searchTerm, setSearchTerm] = useState(searchQuery);

  useEffect(() => {
    const updateCartCount = () => {
      const savedCart = localStorage.getItem('cart');
      if (savedCart) {
        try {
          const cart = JSON.parse(savedCart);
          const count = cart.reduce((sum: number, item: any) => sum + item.quantity, 0);
          setCartCount(count);
        } catch (error) {
          localStorage.removeItem('cart');
          setCartCount(0);
        }
      } else {
        setCartCount(0);
      }
    };
    
    updateCartCount();
    window.addEventListener('storage', updateCartCount);
    
    const handleCartUpdate = () => updateCartCount();
    window.addEventListener('cartUpdated', handleCartUpdate);
    
    return () => {
      window.removeEventListener('storage', updateCartCount);
      window.removeEventListener('cartUpdated', handleCartUpdate);
    };
  }, []);

  const addToCart = (product: any) => {
    const savedCart = localStorage.getItem('cart');
    const cart = savedCart ? JSON.parse(savedCart) : [];
    
    const existingItem = cart.find((item: any) => item.id === product.id);
    if (existingItem) {
      existingItem.quantity += 1;
    } else {
      cart.push({ ...product, quantity: 1 });
    }
    
    localStorage.setItem('cart', JSON.stringify(cart));
    const newCount = cart.reduce((sum: number, item: any) => sum + item.quantity, 0);
    setCartCount(newCount);
    
    window.dispatchEvent(new Event('cartUpdated'));
  };

  const allProducts = [
    {
      id: 1,
      name: 'Viagra 100mg',
      category: 'ED Treatment',
      price: 120.00,
      image: 'https://public.readdy.ai/ai/img_res/23f6d42d6cc4de66a1d16f4dc7183416.jpg',
      rating: 4.8,
      inStock: true,
      link: '/products/viagra-100mg'
    },
    {
      id: 14,
      name: 'Viagra 250mg',
      category: 'ED Treatment',
      price: 120.00,
      image: 'https://readdy.ai/api/search-image?query=professional%20viagra%20sildenafil%20250mg%20tablets%20in%20red%20colored%20pharmaceutical%20packaging%20on%20clean%20white%20surface%20medical%20product%20photography%20soft%20lighting%20high%20quality%20shot%20red%20pills%20blister%20pack&width=400&height=400&seq=250&orientation=squarish',
      rating: 4.9,
      inStock: true,
      link: '/products/viagra-250mg'
    },
    {
      id: 2,
      name: 'Cialis 20mg',
      category: 'ED Treatment',
      price: 120.00,
      image: 'https://readdy.ai/api/search-image?query=professional%20cialis%20tadalafil%20tablets%20in%20pharmaceutical%20blister%20pack%20on%20clean%20white%20background%20medical%20product%20photography%20soft%20lighting%20high%20quality%20shot&width=400&height=400&seq=2&orientation=squarish',
      rating: 4.7,
      inStock: true,
      link: '/products/cialis-20mg'
    },
    {
      id: 3,
      name: 'Levitra 20mg',
      category: 'ED Treatment',
      price: 120.00,
      image: 'https://readdy.ai/api/search-image?query=professional%20levitra%20vardenafil%20tablets%20in%20pharmaceutical%20packaging%20on%20clean%20white%20surface%20medical%20product%20photography%20soft%20lighting%20high%20quality%20shot&width=400&height=400&seq=3&orientation=squarish',
      rating: 4.6,
      inStock: true,
      link: '/products/levitra-20mg'
    },
    {
      id: 108,
      name: 'Levitra 40mg',
      category: 'ED Treatment',
      price: 120.00,
      image: 'https://readdy.ai/api/search-image?query=professional%20levitra%20vardenafil%2040mg%20tablets%20in%20light%20orange%20colored%20pharmaceutical%20packaging%20on%20clean%20white%20surface%20medical%20product%20photography%20soft%20lighting%20high%20quality%20shot%20light%20orange%20pills%20blister%20pack&width=400&height=400&seq=808&orientation=squarish',
      rating: 4.7,
      inStock: true,
      link: '/products/levitra-40mg'
    },
    {
      id: 109,
      name: 'Levitra 60mg',
      category: 'ED Treatment',
      price: 120.00,
      image: 'https://readdy.ai/api/search-image?query=professional%20levitra%20vardenafil%2060mg%20tablets%20in%20purple%20colored%20pharmaceutical%20packaging%20on%20clean%20white%20surface%20medical%20product%20photography%20soft%20lighting%20high%20quality%20shot%20purple%20pills%20blister%20pack&width=400&height=400&seq=810&orientation=squarish',
      rating: 4.8,
      inStock: true,
      link: '/products/levitra-60mg'
    },
    {
      id: 4,
      name: 'Kamagra Oral Jelly 100mg',
      category: 'ED Treatment',
      price: 120.00,
      image: 'https://readdy.ai/api/search-image?query=professional%20kamagra%20oral%20jelly%20sachets%20colorful%20packaging%20on%20clean%20white%20background%20pharmaceutical%20product%20photography%20soft%20lighting%20high%20quality%20shot&width=400&height=400&seq=4&orientation=squarish',
      rating: 4.5,
      inStock: true,
      link: '/products/kamagra-oral-jelly'
    },
    {
      id: 5,
      name: 'Soma 350mg',
      category: 'Pain Relief',
      price: 200.00,
      image: 'https://readdy.ai/api/search-image?query=professional%20soma%20carisoprodol%20muscle%20relaxer%20tablets%20in%20pharmaceutical%20packaging%20on%20clean%20white%20surface%20medical%20product%20photography%20soft%20lighting%20high%20quality%20shot&width=400&height=400&seq=5&orientation=squarish',
      rating: 4.7,
      inStock: true,
      link: '/products/soma-350mg'
    },
    {
      id: 112,
      name: 'Soma 500mg',
      category: 'Pain Relief',
      price: 250.00,
      image: 'https://readdy.ai/api/search-image?query=professional%20soma%20carisoprodol%20500mg%20tablets%20in%20pharmaceutical%20packaging%20on%20clean%20white%20surface%20medical%20product%20photography%20soft%20lighting%20high%20quality%20shot%20white%20round%20pills%20blister%20pack%20muscle%20relaxant&width=400&height=400&seq=812&orientation=squarish',
      rating: 4.7,
      inStock: true,
      link: '/products/soma-500mg'
    },
    {
      id: 110,
      name: 'Tapentadol 100mg',
      category: 'Pain Relief',
      price: 200.00,
      image: 'https://readdy.ai/api/search-image?query=professional%20tapentadol%20pain%20relief%20tablets%20in%20pharmaceutical%20packaging%20on%20clean%20white%20surface%20medical%20product%20photography%20soft%20lighting%20high%20quality%20shot&width=400&height=400&seq=110&orientation=squarish',
      rating: 4.8,
      inStock: true,
      link: '/products/tapentadol-100mg'
    },
    {
      id: 111,
      name: 'Tapentadol 200mg',
      category: 'Pain Relief',
      price: 250.00,
      image: 'https://readdy.ai/api/search-image?query=professional%20tapentadol%20200mg%20pain%20relief%20tablets%20in%20pharmaceutical%20packaging%20on%20clean%20white%20surface%20medical%20product%20photography%20soft%20lighting%20high%20quality%20shot&width=400&height=400&seq=111&orientation=squarish',
      rating: 4.8,
      inStock: true,
      link: '/products/tapentadol-200mg'
    },
    {
      id: 9,
      name: 'Orlistat 120mg',
      category: 'Weight Loss',
      price: 120.00,
      image: 'https://readdy.ai/api/search-image?query=modern%20pharmaceutical%20orlistat%20weight%20loss%20capsules%20in%20professional%20medical%20packaging%20on%20clean%20white%20surface%20with%20soft%20lighting%20medical%20photography%20style%20high%20quality%20product%20shot&width=400&height=400&seq=101&orientation=squarish',
      rating: 4.5,
      inStock: true,
      link: '/products/orlistat'
    },
    {
      id: 10,
      name: 'Amoxicillin 500mg',
      category: 'Antibiotics',
      price: 120.00,
      image: 'https://readdy.ai/api/search-image?query=professional%20amoxicillin%20antibiotic%20capsules%20in%20medical%20blister%20pack%20on%20clean%20white%20background%20pharmaceutical%20product%20photography%20soft%20lighting%20high%20quality%20medical%20shot&width=400&height=400&seq=201&orientation=squarish',
      rating: 4.8,
      inStock: true,
      link: '/products/amoxicillin'
    },
    {
      id: 11,
      name: 'Ibuprofen 400mg',
      category: 'Pain Relief',
      price: 120.00,
      image: 'https://readdy.ai/api/search-image?query=ibuprofen%20pain%20relief%20tablets%20in%20modern%20pharmaceutical%20packaging%20on%20clean%20white%20surface%20professional%20medical%20product%20photography%20soft%20lighting%20high%20quality%20shot&width=400&height=400&seq=301&orientation=squarish',
      rating: 4.7,
      inStock: true,
      link: '/products/ibuprofen'
    },
    {
      id: 12,
      name: 'Alprazolam 0.5mg',
      category: 'Anxiety',
      price: 120.00,
      image: 'https://readdy.ai/api/search-image?query=professional%20alprazolam%20anxiety%20medication%20tablets%20in%20pharmaceutical%20blister%20pack%20on%20clean%20white%20background%20medical%20product%20photography%20soft%20lighting%20high%20quality%20shot&width=400&height=400&seq=401&orientation=squarish',
      rating: 4.6,
      inStock: true,
      link: '/products/alprazolam-0.5mg'
    },
    {
      id: 13,
      name: 'Vitamin D3 5000IU',
      category: 'Vitamins',
      price: 120.00,
      image: 'https://readdy.ai/api/search-image?query=professional%20vitamin%20d3%20supplement%20capsules%20in%20modern%20pharmaceutical%20bottle%20on%20clean%20white%20surface%20medical%20product%20photography%20soft%20lighting%20high%20quality%20shot&width=400&height=400&seq=501&orientation=squarish',
      rating: 4.9,
      inStock: true,
      link: '/products/vitamin-d3-5000iu'
    },
  ];

  const categories = ['All', 'ED Treatment', 'Pain Relief', 'Sleep Aid', 'Weight Loss', 'Antibiotics', 'Anxiety', 'Vitamins'];

  const filteredProducts = allProducts.filter(product => {
    const matchesCategory = selectedCategory === 'All' || product.category === selectedCategory;
    const matchesSearch = product.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
                         product.category.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="text-2xl font-bold text-teal-600" style={{ fontFamily: '"Pacifico", serif' }}>MediCare</Link>
            </div>
            <div className="hidden md:flex items-center space-x-8">
              <Link to="/" className="text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer">Home</Link>
              <a href="/#categories" className="text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer">Categories</a>
              <Link to="/all-products" className="text-teal-600 font-semibold whitespace-nowrap cursor-pointer">Products</Link>
              <Link to="/prescription" className="text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer">Prescription</Link>
              <a href="/#contact" className="text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer">Contact</a>
            </div>
            <div className="flex items-center space-x-4">
              <button className="w-10 h-10 flex items-center justify-center text-gray-700 hover:text-teal-600 transition-colors cursor-pointer">
                <i className="ri-search-line text-xl"></i>
              </button>
              <Link to="/cart" className="w-10 h-10 flex items-center justify-center text-gray-700 hover:text-teal-600 transition-colors cursor-pointer relative">
                <i className="ri-shopping-cart-line text-xl"></i>
                <span className="absolute -top-1 -right-1 bg-teal-600 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">{cartCount}</span>
              </Link>
              <Link to="/auth" className="w-10 h-10 flex items-center justify-center text-gray-700 hover:text-teal-600 transition-colors cursor-pointer">
                <i className="ri-user-line text-xl"></i>
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <div className="bg-gradient-to-r from-teal-50 to-blue-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">All Products</h1>
            <p className="text-lg text-gray-600">Browse our complete range of quality medicines</p>
          </div>
          
          {/* Search Bar */}
          <div className="max-w-2xl mx-auto">
            <div className="flex items-center bg-white rounded-lg shadow-lg p-2">
              <i className="ri-search-line text-gray-400 text-xl ml-4"></i>
              <input
                type="text"
                placeholder="Search for medicines..."
                className="flex-1 px-4 py-3 focus:outline-none text-sm"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Category Filter */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-wrap gap-3 justify-center">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-6 py-2 rounded-full font-semibold transition-colors whitespace-nowrap cursor-pointer ${
                selectedCategory === category
                  ? 'bg-teal-600 text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {category}
            </button>
          ))}
        </div>
      </div>

      {/* Products Grid */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
        <div className="mb-6">
          <p className="text-gray-600">Showing {filteredProducts.length} products</p>
        </div>
        
        {filteredProducts.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-product-shop>
            {filteredProducts.map((product) => (
              <div
                key={product.id}
                className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all group cursor-pointer"
              >
                <Link to={product.link} className="block" onClick={() => window.scrollTo(0, 0)}>
                  <div className="relative overflow-hidden">
                    <img src={product.image} alt={product.name} className="w-full h-64 object-cover object-top group-hover:scale-105 transition-transform duration-300" />
                  </div>
                  <div className="p-6">
                    <p className="text-sm text-teal-600 font-semibold mb-2">{product.category}</p>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">{product.name}</h3>
                    <div className="flex items-center mb-3">
                      <div className="flex items-center">
                        {[...Array(5)].map((_, i) => (
                          <i
                            key={i}
                            className={`${
                              i < Math.floor(product.rating) ? 'ri-star-fill' : 'ri-star-line'
                            } text-yellow-400 text-sm`}
                          ></i>
                        ))}
                      </div>
                      <span className="ml-2 text-sm text-gray-600">({product.rating})</span>
                    </div>
                    <div className="flex items-center justify-between">
                      <p className="text-2xl font-bold text-gray-900">${product.price}</p>
                    </div>
                  </div>
                </Link>
                <div className="px-6 pb-6">
                  <button 
                    onClick={(e) => {
                      e.preventDefault();
                      addToCart(product);
                    }}
                    className="w-full bg-teal-600 text-white px-4 py-2 rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-shopping-cart-line mr-2"></i>
                    Add to Cart
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-16">
            <i className="ri-search-line text-6xl text-gray-300 mb-4"></i>
            <h3 className="text-2xl font-bold text-gray-900 mb-2">No products found</h3>
            <p className="text-gray-600">Try adjusting your search or filter to find what you're looking for.</p>
          </div>
        )}
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-300 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
            <div>
              <h3 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: '"Pacifico", serif' }}>MediCare</h3>
              <p className="text-gray-400 mb-4">Your trusted partner in healthcare, delivering quality medicines to your doorstep.</p>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li><Link to="/" className="hover:text-teal-400 transition-colors cursor-pointer">Home</Link></li>
                <li><Link to="/all-products" className="hover:text-teal-400 transition-colors cursor-pointer">All Products</Link></li>
                <li><Link to="/prescription" className="hover:text-teal-400 transition-colors cursor-pointer">Prescription</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-4">Categories</h4>
              <ul className="space-y-2">
                <li><a href="#" className="hover:text-teal-400 transition-colors cursor-pointer">Weight Loss</a></li>
                <li><a href="#" className="hover:text-teal-400 transition-colors cursor-pointer">Antibiotics</a></li>
                <li><a href="#" className="hover:text-teal-400 transition-colors cursor-pointer">Pain Relief</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-4">Contact Info</h4>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <i className="ri-phone-line mt-1 mr-2"></i>
                  <span>+1 (929) 268-8770</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-mail-line mt-1 mr-2"></i>
                  <span>sam4104t@gmail.com</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-8 text-center">
            <p className="text-gray-400">&copy; 2024 MediCare. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-teal-400 transition-colors cursor-pointer">Powered by Readdy</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}
